import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import PrimaryButton from './PrimaryButton';
import TertiaryButton from './TertiaryButton';

type Props = {
    title: string;
    subtext: string;
    isOpen: boolean;
    handleClose: () => void;
    proceed: () => void;
    proceedButtonText: string;
    proceedButtonClassName?: string;
};

export default function ConfirmDialog({
    title,
    subtext,
    isOpen,
    handleClose,
    proceed,
    proceedButtonText,
    proceedButtonClassName
}: Props) {
    return (
        <Dialog data-testid="dialog" onClose={handleClose} aria-labelledby="simple-dialog-title" open={isOpen}>
            <DialogTitle classes={{ root: 'failure-title' }}>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText classes={{ root: 'failure-subtext' }}>{subtext}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <TertiaryButton onClick={handleClose}>Cancel</TertiaryButton>
                <PrimaryButton onClick={proceed} className={proceedButtonClassName}>
                    {proceedButtonText}
                </PrimaryButton>
            </DialogActions>
        </Dialog>
    );
}
